import _objectSpread from'@babel/runtime/helpers/objectSpread2';import errorsJson from'../translations/errors.js';var ERR_100 = 100;
var ERR_101 = 101;
var ERROR_TYPES = {
  PAGE: 'page',
  // shows in page
  REGULAR: 'regular' // appears in-line in form
};

var ERROR_ROUTE = '/error';
var defineError = function defineError(e) {
  var networkErrorCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ERR_101;
  var errObject = {
    err: e,
    errorCode: ERR_100 // default to 100 always
  };

  if (e.message && e.message === 'Network Error') {
    errObject.errorCode = networkErrorCode;
    errObject.err = e.message;
  } else {
    errObject.errorCode = e.errorCode;
  }
  var errFromJson = errorsJson[errObject.errorCode];
  if (!errFromJson) {
    // if the error number is not in the json then use 100 as default;
    // eslint-disable-next-line prefer-destructuring
    errFromJson = errorsJson[ERR_100];
    if (e.response && e.response.data.error) {
      errObject.errorMessage = e.response.data.errorMessage;
      if (e.response.data.data) {
        errObject.errorMessage += "\ndebug: ".concat(JSON.stringify(e.response.data.data));
      }
    }
  }
  return _objectSpread(_objectSpread({}, errObject), errFromJson);
};export{ERROR_ROUTE,ERROR_TYPES,defineError};